import { Action } from '@ngrx/store';

import * as tempdataActions from '@store/tempdata/tempdata.actions';

import { OrderFilter } from '../shared/order-filter.model';

export const ORD_INQ_INIT = '[ORD INQ] - Initialize';
export const ORD_INQ_REINIT = '[ORD INQ] - Reinitialize';
export const ORD_INQ_CLEAR_FILTER = '[ORD INQ] [FILTER] - Clear Filter';
export const ORD_INQ_SELECT_ROW = '[ORD INQ] [GRID] - Select Row';
export const ORD_INQ_CLEAR_SELECT_ROW = '[ORD INQ] [GRID] - Clear Selected Row';
export const ORD_INQ_MODIFY_ROW = '[ORD INQ] [GRID] - Modify Row';
export const ORD_INQ_SET_FILTER = '[ORD INQ] [FILTER] - Set Filter';
export const ORD_INQ_SET_SHOWING = '[ORD INQ] [MENU] - Change Showing Area';
export const ORD_INQ_REQUEST_DATA = '[ORD INQ] [GRID] - Request Data';
export const ORD_INQ_SET_LOADED_FILTER = '[ORD INQ] [FILTER] - Set Loaded Filter';
export const ORD_INQ_CLEAR_LOADED_FILTER = '[ORD INQ] [FILTER] - Clear Loaded Filter';

export const ORD_DTL_INIT = '[ORD DTL] - Initialize';
export const ORD_DTL_SET_SHOWING = '[ORD DTL] [MENU] - Change Showing Area';
export const ORD_DTL_REQUEST_DATA = '[ORD DTL] [GRID] - Request Data';

export const ORD_MOD_HDR_CREATE_INIT = '[ORD MOD HDR] - Initialize for Create';
export const ORD_MOD_HDR_MODIFY_INIT = '[ORD MOD HDR] - Initialize for Modify';
export const ORD_MOD_HDR_SET_SHOWING = '[ORD MOD HDR] [MENU] - Change Showing Area';
export const ORD_MOD_HDR_SET_ORDER = '[ORD MOD HDR] [MAIN] - Set Orderid and Shipid';
export const ORD_MOD_HDR_CLEAR_ORDER = '[ORD MOD HDR] [MAIN] - Clear Orderid and Shipid';

export const ORD_MOD_HDR_UPDATE_DATA = '[ORD MOD HDR] [MAIN] - Update Orderhdr';
export const ORD_MOD_HDR_UPDATE_DATA_SUCCESS = '[ORD MOD HDR] [MAIN] - Update Orderhdr Success';
export const ORD_MOD_HDR_UPDATE_DATA_FAILURE = '[ORD MOD HDR] [MAIN] - Update Orderhdr Failure';

export const ORD_MOD_HDR_CREATE_INBOUND = '[ORD MOD HDR] [MAIN] - Create Inbound Orderhdr';
export const ORD_MOD_HDR_CREATE_INBOUND_SUCCESS = '[ORD MOD HDR] [MAIN] - Create Inbound Orderhdr Success';
export const ORD_MOD_HDR_CREATE_INBOUND_FAILURE = '[ORD MOD HDR] [MAIN] - Create Inbound Orderhdr Failure';

export const ORD_MOD_HDR_CREATE_OUTBOUND = '[ORD MOD HDR] [MAIN] - Create Outbound Orderhdr';
export const ORD_MOD_HDR_CREATE_OUTBOUND_SUCCESS = '[ORD MOD HDR] [MAIN] - Create Outbound Orderhdr Success';
export const ORD_MOD_HDR_CREATE_OUTBOUND_FAILURE = '[ORD MOD HDR] [MAIN] - Create Outbound Orderhdr Failure';

export const ORD_MOD_DTL_INIT = '[ORD MOD DTL] - Initialize';
export const ORD_MOD_DTL_SET_SHOWING = '[ORD MOD DTL] [MENU] - Change Showing Area';
export const ORD_MOD_DTL_REQUEST_DATA = '[ORD MOD DTL] [GRID] - Request Data';
export const ORD_MOD_DTL_UPDATE_DATA = '[ORD MOD DTL] [MAIN] - Update Orderdtl';

export const ORD_MOD_DTL_UPDATE_BULK_DATA = '[ORD MOD DTL] [MAIN] - Update Orderdtl Bulk';
export const ORD_MOD_DTL_UPDATE_BULK_DATA_SUCCESS = '[ORD MOD DTL] [MAIN] - Update Orderdtl Bulk Success';
export const ORD_MOD_DTL_UPDATE_BULK_DATA_FAILURE = '[ORD MOD DTL] [MAIN] - Update Orderdtl Bulk Failure';

export const ORD_DTL_DELETE_ITEM = '[ORD MOD DTL] [MAIN] - Delete Item';

export const ORD_FLT_SAVE = '[ORD FLT] [FILTER] - Save Filter';
export const ORD_FLT_FETCH = '[ORD FLT] [FILTER] - Fetch Filter';
export const ORD_FLT_DELETE = '[ORD FLT] [FILTER] - Delete Filter';
export const ORD_SET_FILTERS = '[ORD FLT] [FILTER] - Set Filter Data';

export enum OrdInqShowing {
  filter = 'filter',
  colpref = 'colpref',
  grid = 'grid',
}

export class OrdInqInit implements Action {
  readonly type = ORD_INQ_INIT;
}

export class OrdInqReinit implements Action {
  readonly type = ORD_INQ_REINIT;
}

export class OrdInqSetFilter implements Action {
  readonly type = ORD_INQ_SET_FILTER;
  constructor(public filter: OrderFilter) {}
}

export class OrdInqClearFilter implements Action {
  readonly type = ORD_INQ_CLEAR_FILTER;
}

export class OrdInqSetShowing implements Action {
  readonly type = ORD_INQ_SET_SHOWING;
  constructor(public area: string) {}
}

export class OrdInqRequestData implements Action {
  readonly type = ORD_INQ_REQUEST_DATA;
  constructor(public filter: OrderFilter) {}
}

export class OrdInqModifyRow implements Action {
  readonly type = ORD_INQ_MODIFY_ROW;
  constructor(public row: any) {}
}

export class OrdInqSelectRow implements Action {
  readonly type = ORD_INQ_SELECT_ROW;
  constructor(public row: any) {}
}

export class OrdInqClearSelectedRow implements Action {
  readonly type = ORD_INQ_CLEAR_SELECT_ROW;
}

export class OrdInqSetLoadedFilter implements Action {
  readonly type = ORD_INQ_SET_LOADED_FILTER;
  constructor(public id: string) {}
}

export class OrdInqClearLoadedFilter implements Action {
  readonly type = ORD_INQ_CLEAR_LOADED_FILTER;
}

export class OrdDtlInit implements Action {
  readonly type = ORD_DTL_INIT;
}

export class OrdDtlSetShowing implements Action {
  readonly type = ORD_DTL_SET_SHOWING;
  constructor(public area: string) {}
}

export class OrdDtlRequestData implements Action {
  readonly type = ORD_DTL_REQUEST_DATA;
  constructor(public filter: any) {}
}

export class OrdModHdrCreateInit implements Action {
  readonly type = ORD_MOD_HDR_CREATE_INIT;
}

export class OrdModHdrModifyInit implements Action {
  readonly type = ORD_MOD_HDR_MODIFY_INIT;
}

export class OrdModHdrSetShowing implements Action {
  readonly type = ORD_MOD_HDR_SET_SHOWING;
  constructor(public area: string) {}
}

export class OrdModHdrSetOrder implements Action {
  readonly type = ORD_MOD_HDR_SET_ORDER;
  constructor(public data: any) {}
}

export class OrdModHdrClearOrder implements Action {
  readonly type = ORD_MOD_HDR_CLEAR_ORDER;
  constructor(public row: any) {}
}

export class OrdModHdrUpdateData implements Action {
  readonly type = ORD_MOD_HDR_UPDATE_DATA;
  constructor(public data: any) {}
}

export class OrdModHdrUpdateDataSuccess implements Action {
  readonly type = ORD_MOD_HDR_UPDATE_DATA_SUCCESS;
  constructor(public data: any) {}
}

export class OrdModHdrUpdateDataFailure implements Action {
  readonly type = ORD_MOD_HDR_UPDATE_DATA_FAILURE;
  constructor(public data: any) {}
}

export class OrdModHdrCreateInbound implements Action {
  readonly type = ORD_MOD_HDR_CREATE_INBOUND;
  constructor(public data: any) {}
}

export class OrdModHdrCreateInboundSuccess implements Action {
  readonly type = ORD_MOD_HDR_CREATE_INBOUND_SUCCESS;
  constructor(public data: any) {}
}

export class OrdModHdrCreateInboundFailure implements Action {
  readonly type = ORD_MOD_HDR_CREATE_INBOUND_FAILURE;
  constructor(public data: any) {}
}

export class OrdModHdrCreateOutbound implements Action {
  readonly type = ORD_MOD_HDR_CREATE_OUTBOUND;
  constructor(public data: any) {}
}

export class OrdModHdrCreateOutboundSuccess implements Action {
  readonly type = ORD_MOD_HDR_CREATE_OUTBOUND_SUCCESS;
  constructor(public data: any) {}
}

export class OrdModHdrCreateOutboundFailure implements Action {
  readonly type = ORD_MOD_HDR_CREATE_OUTBOUND_FAILURE;
  constructor(public data: any) {}
}

export class OrdModDtlInit implements Action {
  readonly type = ORD_MOD_DTL_INIT;
}

export class OrdModDtlSetShowing implements Action {
  readonly type = ORD_MOD_DTL_SET_SHOWING;
  constructor(public area: string) {}
}

export class OrdModDtlRequestData implements Action {
  readonly type = ORD_MOD_DTL_REQUEST_DATA;
  constructor(public filter: any) {}
}

export class OrdModDtlUpdateData implements Action {
  readonly type = ORD_MOD_DTL_UPDATE_DATA;
  constructor(public data: any) {}
}

export class OrdModDtlUpdateBulkData implements Action {
  readonly type = ORD_MOD_DTL_UPDATE_BULK_DATA;
  constructor(public data: any) {}
}

export class OrdModDtlUpdateBulkDataSuccess implements Action {
  readonly type = ORD_MOD_DTL_UPDATE_BULK_DATA_SUCCESS;
  constructor(public data: any) {}
}

export class OrdModDtlUpdateBulkDataFailure implements Action {
  readonly type = ORD_MOD_DTL_UPDATE_BULK_DATA_FAILURE;
  constructor(public data: any) {}
}

export class OrdDtlDeleteItem implements Action {
  readonly type = ORD_DTL_DELETE_ITEM;
  constructor(public data: any) {}
}

export class OrdFltSave implements Action {
  readonly type = ORD_FLT_SAVE;
  constructor(public data: any) {}
}

export class OrdFltDelete implements Action {
  readonly type = ORD_FLT_DELETE;
  constructor(public data: any) {}
}

export class OrdFltFetch implements Action {
  readonly type = ORD_FLT_FETCH;
  constructor(public data: any) {}
}

export class OrdSetFilters implements Action {
  readonly type = ORD_SET_FILTERS;
  constructor(public data: any) {}
}

export type OrderActions =
  | OrdInqInit
  | OrdInqSetFilter
  | OrdInqClearFilter
  | OrdInqSetShowing
  | OrdInqRequestData
  | OrdInqSelectRow
  | OrdInqClearSelectedRow
  | OrdInqSetLoadedFilter
  | OrdInqClearLoadedFilter
  | OrdDtlSetShowing
  | OrdDtlRequestData
  | OrdDtlDeleteItem
  | OrdModDtlSetShowing
  | OrdModDtlRequestData
  | OrdModDtlUpdateData
  | OrdDtlInit
  | OrdModDtlInit
  | OrdModHdrCreateInit
  | OrdModHdrSetShowing
  | OrdModHdrSetOrder
  | OrdModHdrClearOrder
  | OrdInqModifyRow
  | OrdInqReinit
  | OrdModHdrModifyInit
  | tempdataActions.OrdModHdrSetData
  | OrdModHdrUpdateData
  | OrdModHdrUpdateDataSuccess
  | OrdModHdrUpdateDataFailure
  | OrdModHdrCreateInbound
  | OrdModHdrCreateInboundSuccess
  | OrdModHdrCreateInboundFailure
  | OrdModHdrCreateOutbound
  | OrdModHdrCreateOutboundSuccess
  | OrdModHdrCreateOutboundFailure
  | OrdFltSave
  | OrdFltFetch
  | OrdFltDelete
  | OrdSetFilters
  | OrdModDtlUpdateBulkData
  | OrdModDtlUpdateBulkDataSuccess
  | OrdModDtlUpdateBulkDataFailure;
